import { Radio } from "@blueprintjs/core";
import { FieldGroup, useFGContext } from "nsitools-react";
import * as React from "react";

import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

export interface IFusionDisplayRadioProps {
  label: ETLCodes;
  fusionName: string;
  fusionId1: number;
  fusionId2: number;
  disabled?: boolean;
}

export const FusionDisplayRadio: React.FunctionComponent<IFusionDisplayRadioProps> = ({
  label,
  fusionName,
  fusionId1,
  fusionId2,
  disabled = false,
}) => {
  const [fusionRadioValue, setFusionRadioValue] = React.useState("1");
  const { formik } = useFGContext();
  const { t } = useTl();

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <FieldGroup>
          <FieldGroup columns={[11, 1]}>
            <Radio
  value="1"
  checked={fusionRadioValue === "1"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusionName, fusionId1);
  }}
  disabled={disabled}
  label={t(label)}
  alignIndicator="right"
  />
          </FieldGroup>
        </FieldGroup>
        {/*==================================================================================================*/}
        <FieldGroup>
          <FieldGroup columns={[11, 1]}>
            <Radio
  value="2"
  checked={fusionRadioValue === "2"}
  onChange={(c) => {
    setFusionRadioValue(c.currentTarget.value);
    formik.setFieldValue(fusionName, fusionId2);
  }}
  label={t(label)}
  disabled={disabled}
  alignIndicator="right"
  />
          </FieldGroup>
        </FieldGroup>
      </div>
    </>
  );
};
